import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import './ClipboardTool.scss';
interface ClipboardToolProps {
  textToCopy: string;
}

const ClipboardTool: React.FC<ClipboardToolProps> = ({ textToCopy }) => {
    const [isRotating, setIsRotating] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(textToCopy).then(() => {
          console.log('Text copied to clipboard');
          setIsRotating(true); // Trigger the animation
          setTimeout(() => setIsRotating(false), 1500); // Remove the class after animation
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      };
    

      return (
        <div
          className={`clipboard-tool ${isRotating ? 'spin' : ''}`}
          title='Copy to clipboard'
          onClick={copyToClipboard}
          style={{ cursor: 'pointer' }}
        >
          <FontAwesomeIcon icon={faClipboard} />
        </div>
      );
};

export default ClipboardTool;

